import { useState } from "react";

import { currencyFormatter } from "../../../../../utils/formatter/formatter";
import { computeStoreTotals, STORE_TIER_STYLE } from "../mixQualification.data";

const DARK_GREEN = "#15803d";

// ícones usados só aqui
const ScissorsIcon = ({ size = 13, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="6" cy="6" r="3" /><path d="M8.12 8.12 12 12" /><path d="M20 4 8.12 15.88" />
    <circle cx="6" cy="18" r="3" /><path d="M14.8 14.8 20 20" />
  </svg>
);

const HelpCircleIcon = ({ size = 13, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><path d="M12 17h.01" />
  </svg>
);

// badge de porte da loja 
const TierTag = ({ tier }) => {
  const style = STORE_TIER_STYLE[tier] || STORE_TIER_STYLE.Média;
  return (
    <span style={{
      padding: "2px 10px", borderRadius: "6px", fontSize: "11.5px", fontWeight: "700",
      color: style.color, backgroundColor: style.bg, border: `1px solid ${style.border}`,
    }}>
      {tier}
    </span>
  );
};

const Chevron = ({ open }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2"
    style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.15s", flexShrink: 0 }}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

// Coluna de produtos 
const MixColumn = ({ title, items, side }) => (
  <div>
    <p style={{ fontSize: "12.5px", fontWeight: "700", color: "#1a1a1a", marginBottom: 8 }}>{title}</p>
    {items.map(item => {
      const isNew = side === "future" && item.status === "new";
      const isReview = side === "future" && item.status === "review";
      const isRemoved = side === "current" && item.status === "removed";

      return (
        <div key={item.rank} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, padding: "3px 0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
            <span style={{ fontSize: "11px", color: "#bbb", width: 26, flexShrink: 0 }}>#{item.rank}</span>
            <span style={{
              fontSize: "12.5px",
              color: isRemoved ? "#dc2626" : isNew ? "#16a34a" : isReview ? "#d97706" : "#333",
              fontWeight: isNew ? "700" : "400",
              textDecoration: isRemoved ? "line-through" : "none",
            }}>
              {item.name}
            </span>
          </div>

          {/* tag "NOVO" agora encostada na direita da linha */}
          {isNew && (
            <span style={{
              fontSize: "9.5px", fontWeight: "700", color: "#16a34a", background: "#eafbf1",
              border: "1px solid #cdeedb", borderRadius: "4px", padding: "1px 5px", flexShrink: 0,
            }}>
              NOVO
            </span>
          )}
        </div>
      );
    })}
  </div>
);

//cor do texto de cada tipo de ação
const ACTION_COLOR = { new: "#16a34a", removed: "#dc2626", review: "#2563eb" };

// Linha de ação
const ActionRow = ({ action }) => {
  const iconByType = {
    new: <span style={{ fontSize: "15px", fontWeight: "800", color: ACTION_COLOR.new }}>+</span>,
    removed: <ScissorsIcon color={ACTION_COLOR.removed} />,
    review: <HelpCircleIcon color={ACTION_COLOR.review} />,
  };

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 10, padding: "10px 12px",
      background: "#fff", border: "1px solid #f0f0f0", borderRadius: "8px",
      boxShadow: "0 1px 2px rgba(0,0,0,0.03)", marginBottom: 6,
    }}>
      <span style={{ width: 18, display: "flex", justifyContent: "center", flexShrink: 0 }}>
        {iconByType[action.type]}
      </span>
      <div>
        <p style={{ fontSize: "12.5px", fontWeight: "400", color: ACTION_COLOR[action.type] }}>
          #{action.rank} {action.name}
        </p>
        <p style={{ fontSize: "11px", color: "#999" }}>
          Loja: {currencyFormatter.format(action.storeRevenue)} · rede: {currencyFormatter.format(action.networkRevenue)}
        </p>
      </div>
    </div>
  );
};

// Legenda de cores 
const Legend = () => {
  const items = [
    { color: "#16a34a", label: "Novo no mix" },
    { color: "#dc2626", label: "Saindo do mix" },
    { color: "#d97706", label: "Em avaliação (mantido)" },
  ];
  return (
    <div style={{ display: "flex", gap: 16, fontSize: "11.5px", color: "#666", margin: "12px 0" }}>
      {items.map(it => (
        <span key={it.label} style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: it.color, display: "inline-block" }} />
          {it.label}
        </span>
      ))}
    </div>
  );
};

// Loja 
const StoreRow = ({ store, isOpen, onToggle }) => {

  const totals = computeStoreTotals(store);
  const hasDetail = store.currentMix?.length > 0;

  return (
    <div style={{ border: "1px solid #eee", borderRadius: "10px", marginBottom: 8, overflow: "hidden" }}>
      <button onClick={onToggle} style={{
        width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "13px 16px", background: "#fff", border: "none", cursor: "pointer",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: "13.5px", fontWeight: "700", color: "#1a1a1a" }}>{store.name}</span>
          <TierTag tier={store.tier} />
          <span style={{ fontSize: "13px", fontWeight: "700", color: "#1a1a1a" }}>
            {store.currentSkuCount} SKUs → {store.idealSkuCount} ideal
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          {totals.newCount > 0 && <span style={{ fontSize: "12.5px", fontWeight: "700", color: "#16a34a" }}>+ {totals.newCount}</span>}
          {totals.removedCount > 0 && (
            <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: "12.5px", fontWeight: "700", color: "#dc2626" }}>
              <ScissorsIcon color="#dc2626" /> {totals.removedCount}
            </span>
          )}
          {totals.reviewCount > 0 && (
            <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: "12.5px", fontWeight: "700", color: "#2563eb" }}>
              <HelpCircleIcon color="#2563eb" /> {totals.reviewCount}
            </span>
          )}
          <span style={{ fontSize: "13px", fontWeight: "700", color: "#16a34a", minWidth: 90, textAlign: "right" }}>
            {currencyFormatter.format(totals.expectedRevenue)}
          </span>
          <Chevron open={isOpen} />
        </div>
      </button>

      {isOpen && (
        <div style={{ padding: "14px 16px", borderTop: "1px solid #f0f0f0" }}>
          {hasDetail && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginBottom: 6 }}>
              <MixColumn title="Mix Atual" items={store.currentMix} side="current" />
              <MixColumn title="Mix Futuro" items={store.futureMix} side="future" />
            </div>
          )}

          {/* linha antes de "Ações" */}
          <div style={{ borderTop: "1px solid #f0f0f0", margin: "16px 0 0" }} />

          {/* "Ações" agora sempre aparece — antes sumia quando a lista era vazia */}
          <p style={{ fontSize: "12.5px", fontWeight: "700", color: "#1a1a1a", margin: "12px 0 8px" }}>Ações</p>
          {store.actions.length > 0 ? (
            store.actions.map(action => <ActionRow key={`${action.type}-${action.rank}`} action={action} />)
          ) : hasDetail ? (
            // sem ações: só uma linha cinza mais grossa, sem texto
            <div style={{ borderTop: "2px solid #e5e5e5", margin: "4px 0 8px" }} />
          ) : (
            <p style={{ fontSize: "12px", color: "#999", marginBottom: 8 }}>
              Detalhamento não disponível neste mock para esta loja.
            </p>
          )}

          {hasDetail && (
            <>
              {/* linha antes da legenda de cores */}
              <div style={{ borderTop: "1px solid #f0f0f0", margin: "8px 0 0" }} />
              <Legend />
            </>
          )}

          <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "center",
            backgroundColor: "#f2fbf5", border: "1px solid #cdeedb", borderRadius: "8px",
            padding: "10px 14px", marginTop: 4,
          }}>
            <div>
              <p style={{ fontSize: "12.5px", fontWeight: "700", color: DARK_GREEN }}>Receita projetada nesta loja</p>
              {/* só mostra essa linha quando existe quebra (inclusões/avaliações/realocações) */}
              {totals.breakdown && (
                <p style={{ fontSize: "11px", color: "#5a8a6b" }}>
                  inclusões: {currencyFormatter.format(totals.breakdown.inclusions)} · avaliações: {currencyFormatter.format(totals.breakdown.reviews)}
                </p>
              )}
            </div>
            <p style={{ fontSize: "16px", fontWeight: "800", color: "#16a34a" }}>
              {currencyFormatter.format(totals.expectedRevenue)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

// Lista de todas as lojas do grupo 
export const StorePlanList = ({ stores }) => {
  const [openIds, setOpenIds] = useState({});
  const toggle = (id) => setOpenIds(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <div>
      {stores.map(store => (
        <StoreRow key={store.id} store={store} isOpen={!!openIds[store.id]} onToggle={() => toggle(store.id)} />
      ))}
    </div>
  );
};
